<label *ngIf="label" [for]="inputId">{{label}}</label>
<ng-content></ng-content>
